var map = {
	"./Ashoka/AshokaFeather.json": [
		563,
		0
	],
	"./AshokaMinion/AshokaMinionParticleImpact.json": [
		564,
		1
	],
	"./AshokaMinion/AshokaMinionParticleWave.json": [
		565,
		2
	],
	"./AshokaMinion/smoke.json": [
		566,
		3
	],
	"./Bjorn/BjornAxe.json": [
		518,
		4
	],
	"./Bjorn/BjornCircle.json": [
		519,
		5
	],
	"./Bjorn/BjornE.json": [
		520,
		6
	],
	"./Bjorn/BjornN.json": [
		521,
		7
	],
	"./Bjorn/BjornNE.json": [
		522,
		8
	],
	"./Bjorn/BjornNW.json": [
		523,
		9
	],
	"./Bjorn/BjornS.json": [
		524,
		10
	],
	"./Bjorn/BjornSE.json": [
		525,
		11
	],
	"./Bjorn/BjornSW.json": [
		526,
		12
	],
	"./Bjorn/BjornW.json": [
		527,
		13
	],
	"./Celeste/CelesteCloudBack.json": [
		515,
		14
	],
	"./Celeste/CelesteCloudFront.json": [
		516,
		15
	],
	"./Celeste/CelesteGroundHitParticle.json": [
		517,
		16
	],
	"./Data.json": [
		1098,
		105
	],
	"./Dmitri/DmitriArrow.json": [
		567,
		17
	],
	"./Dmitri/IceSpike1.json": [
		568,
		18
	],
	"./Dmitri/IceSpike2.json": [
		569,
		19
	],
	"./Dmitri/IceSpike3.json": [
		570,
		20
	],
	"./Dmitri/SpikeImpactDust.json": [
		571,
		21
	],
	"./Dmitri/SpikeImpactParticle.json": [
		572,
		22
	],
	"./Dmitri/StompImpact.json": [
		573,
		23
	],
	"./Dmitri/StompImpactDust.json": [
		574,
		24
	],
	"./Dmitri/StompImpactParticle.json": [
		575,
		25
	],
	"./Gustav/GustavAttackPortal.json": [
		576,
		26
	],
	"./Gustav/GustavDustParticleBackLeft.json": [
		577,
		27
	],
	"./Gustav/GustavDustParticleBackRight.json": [
		578,
		28
	],
	"./Gustav/GustavDustParticleFrontLeft.json": [
		579,
		29
	],
	"./Gustav/GustavDustParticleFrontRight.json": [
		580,
		30
	],
	"./Gustav/GustavEmberParticle.json": [
		581,
		31
	],
	"./Gustav/GustavFinalAttackPortal.json": [
		582,
		32
	],
	"./Gustav/GustavFinalDustParticleBackLeft.json": [
		583,
		33
	],
	"./Gustav/GustavFinalDustParticleBackRight.json": [
		584,
		34
	],
	"./Gustav/GustavFinalDustParticleFrontLeft.json": [
		585,
		35
	],
	"./Gustav/GustavFinalDustParticleFrontRight.json": [
		586,
		36
	],
	"./Gustav/GustavFinalGroundHitParticle.json": [
		587,
		37
	],
	"./Gustav/GustavFinalSwordParticle.json": [
		588,
		38
	],
	"./Gustav/GustavGroundHitParticle.json": [
		589,
		39
	],
	"./Gustav/GustavSwordParticle.json": [
		590,
		40
	],
	"./Gustav/smoke.json": [
		591,
		41
	],
	"./Jin/Jin-RightWaterSplash.json": [
		528,
		42
	],
	"./Jin/Jin_HydropumpImpact.json": [
		529,
		43
	],
	"./Jin/Jin_LeftWaterSplash.json": [
		530,
		44
	],
	"./Jin/Jin_WaterErupt.json": [
		531,
		45
	],
	"./Jin/Jin_WaterEruptParticle.json": [
		532,
		46
	],
	"./Nesha/LaserParticle_1.json": [
		533,
		47
	],
	"./Nesha/LaserParticle_2.json": [
		534,
		48
	],
	"./Nesha/LaserParticle_3.json": [
		535,
		49
	],
	"./Nesha/LaserParticle_4.json": [
		536,
		50
	],
	"./Nesha/LaserParticle_5.json": [
		537,
		51
	],
	"./Nesha/LaserParticle_6.json": [
		538,
		52
	],
	"./Nesha/LaserParticle_7.json": [
		539,
		53
	],
	"./Nesha/Laser_1.json": [
		540,
		54
	],
	"./Nesha/Laser_2.json": [
		541,
		55
	],
	"./Nesha/Laser_3.json": [
		542,
		56
	],
	"./Nesha/Laser_4.json": [
		543,
		57
	],
	"./Nesha/Laser_5.json": [
		544,
		58
	],
	"./Nesha/Laser_6.json": [
		545,
		59
	],
	"./Nesha/Laser_7.json": [
		546,
		60
	],
	"./Nesha/Laser_8.json": [
		547,
		61
	],
	"./Nesha/Laser_9.json": [
		548,
		62
	],
	"./Nesha/Smoke.json": [
		549,
		63
	],
	"./Penguin/Borris.json": [
		592,
		64
	],
	"./Penguin/Kelvin.json": [
		593,
		65
	],
	"./Penguin/Robert.json": [
		594,
		66
	],
	"./Penguin/smoke.json": [
		595,
		67
	],
	"./Robin/arrow.json": [
		1097,
		68
	],
	"./Shaka/DmitriArrow.json": [
		1099,
		106
	],
	"./Shaka/IceSpike1.json": [
		1100,
		107
	],
	"./Shaka/IceSpike2.json": [
		1101,
		108
	],
	"./Shaka/IceSpike3.json": [
		1102,
		109
	],
	"./Shaka/SpikeImpactDust.json": [
		1103,
		110
	],
	"./Shaka/SpikeImpactParticle.json": [
		1104,
		111
	],
	"./Shaka/StompImpact.json": [
		1105,
		112
	],
	"./Shaka/StompImpactDust.json": [
		1106,
		113
	],
	"./Shaka/StompImpactParticle.json": [
		1107,
		114
	],
	"./ShakaMinion/weapon.json": [
		1108,
		115
	],
	"./Tenko/TenkoBall_1.json": [
		596,
		69
	],
	"./Tenko/TenkoBall_2.json": [
		597,
		70
	],
	"./Tenko/TenkoBall_3.json": [
		598,
		71
	],
	"./Tenko/Tenko_Blast1.json": [
		599,
		72
	],
	"./Tenko/Tenko_Blast2.json": [
		600,
		73
	],
	"./TenkoMinion/Aka.json": [
		601,
		74
	],
	"./TenkoMinion/Aki.json": [
		602,
		75
	],
	"./TenkoMinion/Aku.json": [
		603,
		76
	],
	"./TenkoMinion/smoke.json": [
		604,
		77
	],
	"./Vonder/acorn.json": [
		508,
		78
	],
	"./Vonder/acornLoop.json": [
		509,
		79
	],
	"./Vonder/acornReal.json": [
		510,
		80
	],
	"./Vonder/innerPortal.json": [
		511,
		81
	],
	"./Vonder/innerPortalLoop.json": [
		512,
		82
	],
	"./Vonder/outerPortal.json": [
		513,
		83
	],
	"./Vonder/outerPortalLoop.json": [
		514,
		84
	],
	"./Wendy/acorn.json": [
		550,
		85
	],
	"./Wendy/acornLoop.json": [
		551,
		86
	],
	"./Wendy/acornReal.json": [
		552,
		87
	],
	"./Wendy/innerPortal.json": [
		553,
		88
	],
	"./Wendy/innerPortalLoop.json": [
		554,
		89
	],
	"./Wendy/outerPortal.json": [
		555,
		90
	],
	"./Wendy/outerPortalLoop.json": [
		556,
		91
	],
	"./Yamato/Blast1.json": [
		557,
		92
	],
	"./Yamato/Blast2.json": [
		558,
		93
	],
	"./Yamato/Fireball.json": [
		559,
		94
	],
	"./Yamato/Firework1.json": [
		560,
		95
	],
	"./Yamato/Firework2.json": [
		561,
		96
	],
	"./Yamato/Fireworkstart.json": [
		562,
		97
	],
	"./bandits_blade.json": [
		1109,
		116
	],
	"./explosion.json": [
		1110,
		117
	],
	"./sakura.json": [
		1111,
		118
	],
	"./smoke.json": [
		1112,
		119
	],
	"./test.json": [
		1113,
		120
	],
	"./testConfig.json": [
		1114,
		121
	],
	"./testConfig2.json": [
		1115,
		122
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1078;
module.exports = webpackAsyncContext;